var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cp ms-hover c_theme",on:{"click":function($event){return _vm.topage()}}},[_vm._v(" "+_vm._s(_vm.datatext)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }